import productMeta from "./productMeta";

// Page titles and meta descriptions (source: Brave_Athleisure_Page_Meta.pdf, Part 1).
// Title <= 60 characters, description <= 155 characters.
export const SITE_URL = "https://braveathleisure.com";
export const SITE_NAME = "BRAVE Athleisure";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/brave-logo.png`;

// Keyed by lower-case path.
export const staticPageMeta = {
    "/": {
        title: "BRAVE Athleisure | MMA Walkout Gear & Training Wear",
        description: "Shop BRAVE MMA gear: fighter walkout shorts and T-shirts, rashguards, gloves, training wear and collectibles. Order online in Bahrain.",
    },
    "/shop": {
        title: "Shop MMA Walkout Gear, Rashguards & Training Wear | BRAVE",
        description: "Browse the full BRAVE range: walkout shorts and T-shirts, rashguards, MMA gloves, training wear, bags and collectibles. Prices in BHD.",
    },
    "/about": {
        title: "About BRAVE Athleisure | MMA Gear for Fighters & Fans",
        description: "Learn about BRAVE Athleisure, the online store for BRAVE fighter walkout gear, training wear and collectibles.",
    },
    "/contact": {
        title: "Contact Us | BRAVE Athleisure Customer Support",
        description: "Questions about an order, sizing or returns? Contact the BRAVE Athleisure team and we'll get back to you quickly.",
    },
    "/faq": {
        title: "FAQ: Sizing, Orders & Delivery | BRAVE Athleisure",
        description: "Answers to common questions about BRAVE Athleisure sizing, orders, payment, delivery and returns. Find what you need fast.",
    },
    "/shipping-policy": {
        title: "Shipping Policy: Delivery Times & Costs | BRAVE Athleisure",
        description: "See BRAVE Athleisure delivery options, shipping costs, processing times and order tracking details before you check out.",
    },
    "/returns-refunds": {
        title: "Returns & Refunds Policy | BRAVE Athleisure",
        description: "Need to return or exchange an item? Read the BRAVE Athleisure returns and refunds policy, including eligibility and how to start a return.",
    },
    "/payment-method": {
        title: "Payment Methods | Secure Checkout | BRAVE Athleisure",
        description: "View the payment methods accepted at BRAVE Athleisure and how we keep your checkout safe and secure.",
    },
    "/privacy-policy": {
        title: "Privacy Policy | BRAVE Athleisure",
        description: "How BRAVE Athleisure collects, uses and protects your personal information when you browse, shop and contact us.",
    },
    "/terms-conditions": {
        title: "Terms & Conditions | BRAVE Athleisure",
        description: "The terms and conditions for using the BRAVE Athleisure website and placing orders, including pricing, payments, delivery and returns.",
    },
};

// Old CamelCase routes -> the canonical kebab-case URL in the PDF.
export const legacyPathAliases = {
    "/shippingpolicy": "/shipping-policy",
    "/returnsrefunds": "/returns-refunds",
    "/paymentmethod": "/payment-method",
    "/privacypolicy": "/privacy-policy",
    "/termsconditions": "/terms-conditions",
};

// Pages that must not be indexed (account, checkout, admin and utility pages).
const noindexPrefixes = [
    "/admin", "/profile", "/cart", "/checkout", "/login", "/signup", "/signin",
    "/orders", "/order", "/me", "/password", "/process", "/success", "/shipping",
    "/search", "/error", "/shopcategory",
];

export const isNoindexPath = (pathname = "") => {
    const path = pathname.toLowerCase();
    return noindexPrefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
};

const clamp = (text, max) => {
    const value = String(text || "").trim();
    if (value.length <= max) return value;
    return `${value.slice(0, max - 1).trimEnd()}…`;
};

// Title/description for a product: the PDF text when the ID is listed, otherwise generated from the product name.
export const getProductMeta = (product, id) => {
    const listed = productMeta[id || product?._id];
    if (listed) {
        return { title: listed[0], description: listed[1] };
    }

    const name = String(product?.name || "").trim();
    if (!name) {
        return { title: `Product | ${SITE_NAME}`, description: `Shop BRAVE MMA gear online from ${SITE_NAME}.` };
    }

    const suffix = ` | ${SITE_NAME}`;
    const hasSizes = Array.isArray(product?.Size) && product.Size.length > 0;
    const callToAction = hasSizes ? "Choose your size and order online" : "Order online";
    return {
        title: clamp(name, 60 - suffix.length) + suffix,
        description: clamp(`${name}. ${callToAction} from ${SITE_NAME}.`, 155),
    };
};
